module.exports = __webpack_public_path__ + "media/images/background-3-66a1a5205a120340d87019fd707019d2.svg";